<template>
  <div
    class="equipmentManagement mainPageBg"
    v-loading="$store.state.user.loadingState"
  >
    <div class="leftMenuBox">
      <ChoiceList @getSelectMenu="getSelectMenu" />
    </div>
    <div class="rightBox">
      <div class="details commonWrap">
        <DetailsList :activeItem="activeItem" />
      </div>
      <div class="rightMenuBox">
        <div class="cardBox" v-if="loadList.length != 0">
          <LoadDataCom :loadList="loadList" />
        </div>
        <div
          class="contentBox commonWrap"
          :style="{ height: loadList.length == 0 ? '100%' : '87%' }"
        >
          <div class="menuBox">
            <TabMenuCom :activeItem="activeItem" />
          </div>
          <div class="detailedBox">
            <ChartLine
              v-if="activeName == '参数'"
              :activeItem="activeItem"
              :activeParamsOption="activeParamsOption"
              :activeIdWithParams="activeIdWithParams"
            />
            <RunningTime
              v-if="
                judgeAuthority('shebei:equipmentmanagement:edit') &&
                activeName == '时间设置'
              "
              :activeItem="activeItem"
            />
            <WorkRecord
              v-if="activeName == '工单记录'"
              :activeItem="activeItem"
            />
            <WarningRecord
              v-if="activeName == '报警记录'"
              :activeItem="activeItem"
            />
            <AlarmConfiguration
              v-if="
                judgeAuthority('shebei:equipmentmanagement:edit') &&
                activeName == '预警设置'
              "
              :activeItem="activeItem"
            />
            <TimeOff
              v-if="
                judgeAuthority('shebei:equipmentmanagement:edit') &&
                activeName == '定时关闭'
              "
              :activeItem="activeItem"
            />
            <AutomaticControl
              v-if="
                judgeAuthority('shebei:equipmentmanagement:edit') &&
                activeName == '自动控制'
              "
              :activeItem="activeItem"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import ChoiceList from "@/components/shebeiguanli/equipment/ChoiceList";
import LoadDataCom from "@/components/shebeiguanli/equipment/LoadDataCom";
import TabMenuCom from "@/components/shebeiguanli/equipment/TabMenuCom";
import DetailsList from "@/components/shebeiguanli/equipment/DetailsList";
import AlarmConfiguration from "@/components/shebeiguanli/AlarmConfiguration.vue";
import ChartLine from "@/components/shebeiguanli/equipment/ChartLine.vue";
import RunningTime from "@/components/shebeiguanli/RunningTime.vue";
import WarningRecord from "@/components/shebeiguanli/equipment/WarningRecord.vue";
import WorkRecord from "@/components/shebeiguanli/equipment/WorkRecord.vue";
import TimeOff from "@/components/shebeiguanli/equipment/TimeOff.vue";
import AutomaticControl from "@/components/shebeiguanli/equipment/AutomaticControl.vue";
import {
  judgeAuthority,
  getProjectVal,
  handleNumDecimal,
} from "@/assets/js/utils";
export default {
  components: {
    ChoiceList,
    DetailsList,
    AlarmConfiguration,
    ChartLine,
    RunningTime,
    WorkRecord,
    WarningRecord,
    LoadDataCom,
    TabMenuCom,
    TimeOff,
    AutomaticControl,
  },
  data() {
    return {
      activeItem: {},
      activeName: "",
      activeParamsOption: [],
      loadList: [],
      activeIdWithParams: "",
    };
  },
  watch: {
    // activeName: {
    //   handler(newvalue, oldvalue) {
    //     console.log(this.activeName);
    //   },
    //   deep: true,
    // },
  },
  methods: {
    judgeAuthority,
    getSelectMenu(data) {
      // console.log("树选择", data);
      if (!data) {
        this.$message.error("请选择具体的设备");
        return;
      }
      this.activeItem = data;
      this.getLoadData();
      this.$store.commit("SET_LOADING", true);
      setTimeout(() => {
        this.$store.commit("SET_LOADING", false);
      }, 1000);
    },
    async getLoadData() {
      this.loadList = [];
      let res = await api.getSDeviceLoadData({
        deviceId: this.activeItem.id.id,
        type: this.activeItem.type,
        projectId: getProjectVal("Id"),
      });
      if (res && res.data.code == 200 && res.data.data.length) {
        let loadData = [];
        res.data.data.forEach((el) => {
          if (!loadData.some((e) => e.display == el.display)) {
            loadData.push(el);
          }
        });
        // if (this.activeItem.label == "用能设备") {
        //   let arr = { display: "负载率", value: null, unit: "%" },
        //     num = null;
        //   num =
        //     loadData[0].value && loadData[1].value
        //       ? (loadData[0].value / loadData[1].value) * 100
        //       : null;
        //   arr.value = num
        //     ? Number.isInteger(num)
        //       ? num
        //       : num.toFixed(2)
        //     : null;
        //   loadData.splice(2, 0, arr);
        // }
        loadData = loadData.filter((v) => {
          return v.display != "耗电量";
        });
        loadData.map((v) => {
          if (v.display.includes("运行时间")) {
            let va = handleNumDecimal(v.value / 60);
            v.value = handleNumDecimal(va > 24 ? va / 24 : va);
            v.unit = va > 24 ? "天" : "H";
          } else if (v.display.includes("开关状态")) {
            v.value = v.value == 0 ? "关闭" : "开启";
          } else {
            if (!isNaN(Number(v.value))) {
              v.value = handleNumDecimal(v.value);
            }
          }
        });
        this.loadList = loadData;
      }
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.equipmentManagement {
  @include setFlexBetween;

  .leftMenuBox {
    @include setMenuWH;
    @include setFlexCenter;
  }
  .rightBox {
    @include setCenterWH;
    @include setFlexBetween;
    .details {
      width: 25%;
      height: 100%;
      overflow: auto;
      @include setFlexCenter;
    }
    .rightMenuBox {
      width: calc(75% - 12px);
      height: 100%;
      @include setFlexColumn;
      justify-content: space-between;
      .cardBox {
        height: 11%;
      }
      .contentBox {
        .menuBox {
          width: 98%;
          height: 7%;
          margin: 10px auto 0;
        }

        .detailedBox {
          width: 100%;
          height: calc(93% - 20px);
          margin: 10px auto 0;
        }
      }
    }
  }
}
</style>
